import { render } from "./CardPreview.vue?vue&type=template&id=ab96f1de&scoped=true"
import script from "./CardPreview.vue?vue&type=script&lang=js"
export * from "./CardPreview.vue?vue&type=script&lang=js"

import "./CardPreview.vue?vue&type=style&index=0&id=ab96f1de&lang=css"
import "./CardPreview.vue?vue&type=style&index=1&id=ab96f1de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab96f1de"]])

export default __exports__